<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="dedicenter"><a id="pVI">This book is dedicated in admiration to all those who fight multiple sclerosis</a></p><a id="pVI">
</a></div><a id="pVI">
<p class="pbreak">
</p></a><div class="epi"><a id="pVI">
</a><p class="epi"><a id="pVI"></a><a id="pVII">‘It was so harsh a winter that no-one could remember another like it … only after Easter could the peasants go to their fields and begin to farm’</a></p><a id="pVII">
<p class="epis">(Hans Heberle, <i>Zeytregister [Diary]</i>, Ulm, Germany, 1627)</p>
</a></div><a id="pVII">
<div class="epi">
<p class="epi">‘The times here are so miserable that never in the memory of man has the like famine and mortality happened’</p>
<p class="epis">(East India Company officials, letter, Surat, India, 1631)</p>
</div>
<div class="epi">
<p class="epi">‘Those who live in times to come will not believe that we who are alive now have suffered such toil, pain and misery’</p>
<p class="epis">(Fra Francesco Voersio of Cherasco, <i>Diario del contagio [Plague Diary]</i>, Italy, 1631)</p>
</div>
<div class="epi">
<p class="epi">‘There have been so many deaths that the like of it has never been heard in human history’</p>
<p class="epis">(Hans Conrad Lang, <i>Tagebuch [Diary]</i>, South Germany, 1634)</p>
</div>
<div class="epi">
<p class="epi">‘Jiangnan has never experienced this kind of disaster’</p>
<p class="epis">(Lu Shiyi, <i>Zhixue lu [Diary]</i>, South China, 1641)</p>
</div>
<div class="epi">
<p class="epi">‘Among all the past occurrences of disaster and rebellion, there had never been anything worse than this’</p>
<p class="epis">(<i>County Gazetteer</i>, Yizhou, North China, 1641)</p>
</div>
<div class="epi">
<p class="epi">‘The whole monarchy trembled and shook, since Portugal, Catalonia, the East Indies, the Azores and Brazil had rebelled’</p>
<p class="epis">(Viceroy don Juan de Palafox y Mendoza, Mexico, 1641)</p>
</div>
<div class="epi">
<p class="epi">‘[These] days are days of shaking and this shaking is universal: the Palatinate, Bohemia, Germany, Catalonia, Portugal, Ireland, England’</p>
<p class="epis">(Jeremiah Whitaker, <i>Ejrenopojos [The peacemaker]</i>, England, 1643)</p>
</div>
<div class="epi">
<p class="epi">‘This seems to be one of the epochs in which every nation is turned upside down, leading some great minds to suspect that we are approaching the end of the world’</p>
<p class="epis">(<i>Nicandro [The victor]</i>, pamphlet, Madrid, Spain, 1643)</p>
</div>
<div class="epi">
<p class="epi">‘'Tis tru we have had many such black days in England in former ages, but those parallel'd to the present are to the shadow of a mountain compar'd to the eclipse of the moon’</p>
<p class="epis">(James Howell, <i>Collected letters</i>, England, 1647)</p>
</div>
</a><div class="epi"><a id="pVII">
</a><p class="epi"><a id="pVII"></a><a id="pVIII">‘There was great hunger throughout the Christian world’</a></p><a id="pVIII">
<p class="epis">(Inscription, Old Sambor Cathedral, Ukraine, 1648)</p>
</a></div><a id="pVIII">
<div class="epi">
<p class="epi">‘The pryces of victuall and cornes of all sortes wer heigher than ever heirtofore aneyone living could remember … The lyke had never beine seine in this kingdome’</p>
<p class="epis">(Sir James Balfour, ‘Some shorte memorialls and passages of this yeire’, Scotland, 1649)</p>
</div>
<div class="epi">
<p class="epi">‘If one ever had to believe in the Last Judgment, I think it is happening right now’</p>
<p class="epis">(Judge Renaud de Sévigné, letter, Paris, France, 1652)</p>
</div>
<div class="epi">
<p class="epi">‘The elements, servants of an irate God, combine to snuff out the rest of humankind: mountains spew out fire; the earth shakes; plague contaminates the air’</p>
<p class="epis">(Jean-Nicolas de Parival, <i>Abrégé de l'histoire de ce siècle de fer [Short history of this Iron Century]</i>, Brussels, South Netherlands, 1653)</p>
</div>
<div class="epi">
<p class="epi">‘A third of the world has died’</p>
<p class="epis">(Abbess Angélique Arnauld, letter, Port-Royale-des-Champs, France, 1654)</p>
</div>
<div class="epi">
<p class="epi">‘I no sooner perceived myself in the world but I found myself in a storm, which hath lasted almost hitherto’</p>
<p class="epis">(John Locke, ‘First Tract on Government’, London, 1660)</p>
</div>
<div class="epi">
<p class="epi">‘Because of the dearth sent to us by God, we wanted to sell our property to our relatives, but they refused, and left us to die from hunger’</p>
<p class="epis">(Gavril Niţă, Moldavian peasant, 1660)</p>
</div>
<div class="epi">
<p class="epi">‘Transylvania never knew such misery as this last year’.</p>
<p class="epis">(Mihail Teleki, Chancellor of Transylvania, <i>Journal</i>, 1661)</p>
</div>
<div class="epi">
<p class="epi">‘So many prophets and prophetesses arose in all the cities of Anatolia that everyone believed wholeheartedly that the End of Days had come … These were indeed miraculous occurrences and wonders, the like of which had never happened since the day the world was created’</p>
<p class="epis">(Leib ben Oyzer, <i>Beschraybung fun Shabsai Zvi [Description of Shabbatai Zvi]</i>, on events in the Ottoman empire in 1665–6)</p>
</div>
<div class="epi">
<p class="epi">‘The world was aflame from the time I was 15 [1638] to the time I was 18’</p>
<p class="epis">(Enomoto Yazaemon, <i>Oboegaki [Memoranda]</i>, Saitama, Japan, 1670)</p>
</div>
<div class="epi">
<p class="epi">‘Since [1641] I am not afraid of seeing dead people, because I saw so many of them at that time’</p>
<p class="epis">(Yao Tinglin, <i>Linian ji [Record of successive years]</i>, Shanghai, China, c. 1670)</p>
</div>
</a><div class="epi"><a id="pVIII">
</a><p class="epi"><a id="pVIII"></a><a id="pIX">‘Many people held their lives to be of no value, for the area was so wasted and barren, the common people so poor and had suffered so much, that essentially they knew none of the joys of being alive … Every day one would hear that someone had hanged himself from a beam and killed himself. Others, at intervals, cut their throats or threw themselves into the river’</a></p><a id="pIX">
<p class="epis">(Huang Liuhong, <i>Fuhui quanshu [Complete book concerning happiness and benevolence]</i>, about events in Shandong, China, c. 1670)</p>
</a></div><a id="pIX">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005Dedication.vue?49e463a0